module.exports = {
  become_our_partner: 'Word onze partner',
  select_language: 'Kies de taal:',
  privacy_intro_title: 'Privacybeleid',
  privacy_intro_paragraph:
    'Deze privacyverklaring informeert u over hoe wij uw persoonlijke gegevens beschermen en de maatregelen die wij nemen om ze te beveiligen.',
  privacy_paragraph_1:
    'Hier kunt u ontdekken welke informatie wij gebruiken om onze reeks vervoersdiensten te bieden, hoe wij uw gegevens gebruiken om uw veiligheid te waarborgen en welke keuzes en controles er voor u beschikbaar zijn.\n\nIn deze verklaring worden ook alle mogelijke rechten die u heeft met betrekking tot de privacy van uw gegevens beschreven. De regels voor gegevensbescherming zijn opgesteld om alle betrokkenen te beschermen.',
  privacy_paragraph_2:
    'De term « wij » verwijst naar het bedrijf Nobel, dat is opgericht en geregistreerd in overeenstemming met de wetten van de overheid. De term « u » verwijst naar de personen die onze applicatiedienst gebruiken om een transportdienst aan te vragen, in te huren en/of te ontvangen.',

  personal_data_title: '1. Persoonlijke gegevens die wij verwerken',
  personal_data_paragraph:
    'Wij verwerken alleen de informatie die nodig is voor uw behoeften op onze marktplaats. Dit stelt ons in staat om u de best mogelijke service te bieden voor wat u probeert te bereiken.',

  contact_details_title: 'Contactgegevens:',
  contact_details_paragraph:
    'Wij vragen om uw persoonlijke gegevens zoals naam, telefoonnummer en e-mailadres zodat we u beter kunnen helpen. Profielinformatie: Wij verzamelen bepaalde gegevens om u te helpen uw profiel aan te maken, zoals opgeslagen adressen en taalvoorkeuren. Sommige van onze diensten vereisen aanvullende informatie, zoals uw rijbewijsnummer.',

  geolocation_title: 'Geolocatie:',
  geolocation_paragraph:
    'Door toegang te krijgen tot uw locatie kunnen we u een lijst van beschikbare diensten op uw locatie aanbieden, zoals lokale vervoersopties. Dit geeft de geschatte reistijd weer met verschillende uitgavenopties. Er is ook informatie over uw bestemming en verkeersomstandigheden.',

  payment_details_title: 'Betalingsgegevens:',
  payment_details_paragraph:
    'Informatie over de gebruikte betaalmethode, zoals het bedrag dat in rekening is gebracht en de gebruikte kaart.',

  in_app_communication_title: 'Berichten in de app:',
  in_app_communication_paragraph:
    'We monitoren hoe u regelmatig met onze app omgaat om ervoor te zorgen dat we u de best mogelijke service bieden. We bewaren ook een record van uw berichten in de app zodat we snel contact kunnen opnemen als dat nodig is.',

  limited_identification_data_title: 'Beperkte identificatiegegevens:',
  limited_identification_data_paragraph:
    'We verzamelen het IP-adres van het apparaat waarop de app is geïnstalleerd.',

  ride_data_title: 'Ritgegevens:',
  ride_data_paragraph:
    'De gegevens die we verzamelen over het gebruik van de service, zoals de reistijd, de genomen route, enz. Deze tijdstempels en statistieken stellen ons in staat om eenvoudig te plannen en zijn waardevol voor de veiligheid van de chauffeurs.',

  in_app_message_data_title: 'Berichtgegevens in de app:',
  in_app_message_data_paragraph:
    "Onze ingebouwde chat in de app verzamelt informatie over de datum, tijd en inhoud van uw communicatie met een chauffeur. Gebruikersafbeelding: Voor verificatiedoeleinden slaat onze app de profielfoto's van gebruikers op bij https://nobel.adminkloud.com/public Gebruik van gegevens.",

  platform_data_collection:
    'Het gebruik van het platform verzamelt automatisch gegevens.',
  usage_data_paragraph1:
    "Gebruiksgegevens zijn informatie over uw apparaat, browser en activiteit op de website. Dit kan ons vertellen welk type apparaat u gebruikt, het besturingssysteem, de versie van de browser / iTunes-versie (indien beschikbaar), de pagina's die u bezoekt op onze website voor klantenondersteuning en externe diensten zoals hardware- en softwarebeheer.",
  usage_data_paragraph2:
    'Wanneer u onze website bezoekt of de mobiele app gebruikt, kunnen we automatisch bepaalde gegevens verzamelen zonder menselijke interactie. Dit omvat, maar is niet beperkt tot, uw IP-adres, het type apparaat, het apparaat-ID-nummer, het besturingssysteem van uw apparaat, netwerkstatus en uw huidige locatie. Zelfs wanneer de app niet wordt gebruikt, kan het apparaat nog steeds uw locatie ophalen en ritaanvragen mogelijk maken.',

  website_app_visit_data:
    'Wij verzamelen informatie over uw bezoeken aan onze website of het gebruik van onze app, inclusief elk mobiel apparaat dat u gebruikt.',

  cookies_tracking_technologies_title: 'Trackingtechnologieën en cookies',
  cookies_tracking_technologies_paragraph:
    'Wij gebruiken cookies, tags, tracking tags en scripts om de activiteit op onze dienst te volgen en bepaalde informatie op te slaan. Deze technologieën stellen ons in staat om gegevens te verzamelen en te analyseren om de prestaties te verbeteren en een betere gebruikerservaring te bieden.',

  browser_cookie_options:
    'Uw webbrowser biedt u de mogelijkheid om te kiezen welke soorten cookies u wel of niet accepteert. Zonder deze mogelijkheid kunnen bepaalde delen van onze website mogelijk niet goed functioneren.',

  persistent_session_cookies:
    "Cookies kunnen 'persistente' cookies of 'sessie' cookies zijn. Het verschil is dat persistente cookies op een persoonlijke computer of mobiel apparaat blijven staan, zelfs wanneer de gebruiker de webbrowser sluit, terwijl sessiecookies worden verwijderd zodra ze niet meer in gebruik zijn.",

  cookies_usage_purpose:
    'Wij gebruiken zowel sessiecookies als persistente cookies voor de onderstaande doeleinden:',

  necessary_essential_cookies: 'Nodige / Essentiële Cookies',
  session_cookies: 'Type: Sessie Cookies<br />Beheerd door: Ons',

  cookies_purpose_title: 'Doel:',
  cookies_purpose_paragraph:
    'Cookies worden gebruikt om gebruikers te authenticeren en fraude te voorkomen. Ze helpen u om door de website te navigeren en sommige van de beschikbare diensten te gebruiken. Cookies stellen ons in staat om de diensten te leveren die u heeft aangevraagd, wat belangrijk is voor ons bedrijf. Zonder deze cookies kunnen we deze diensten niet leveren en zou het moeilijk zijn om dat te doen.',

  cookies_policy_notice_title: 'Cookiebeleid / Acceptatie van Cookie-melding',
  persistent_cookies: 'Type: Persistente Cookies<br />Beheerd door: Ons',

  cookies_acceptance_paragraph:
    'Deze cookies identificeren of een bezoeker de cookies op de website heeft geaccepteerd.',

  functionality_cookies_paragraph:
    'Functionele cookies bieden een gepersonaliseerde ervaring op onze website. Ze helpen ons uw voorkeuren te onthouden, uw accountgegevens weer te geven en meer. Deze cookies worden gebruikt op de website om u een aangenamere ervaring te bieden en om te voorkomen dat we steeds om uw voorkeuren moeten vragen.',

  cookies_functionality_paragraph:
    'Voor meer informatie over de cookies die wij gebruiken en uw keuzes met betrekking tot cookies, kunt u ons cookiebeleid raadplegen.',

  cookies_more_info:
    'Dit is het cookiebeleid dat onze cookies en uw keuzes beschrijft.',

  purpose_of_processing_title: '2. Doel van de verwerking',
  purpose_of_processing_paragraph_1:
    'Wij verwerken uw persoonlijke gegevens zodat we u de diensten die u nodig heeft efficiënter kunnen aanbieden:',
  connect_driver_title: 'Om u te verbinden met een chauffeur:',
  connect_driver_paragraph:
    "Wij verzamelen persoonlijke gegevens zodat we gebruikers kunnen verbinden die opgehaald en afgezet willen worden. Deze diensten omvatten auto's, fietsen en scooters die beschikbaar zijn in nabijgelegen gebieden. De directe berichten die de app gebruikt, kunnen worden gebruikt voor klantenservice en om geschillen tussen chauffeurs en passagiers op te lossen. Dit is ook nuttig wanneer ze deze gegevens gebruiken om hun producten en diensten te verbeteren en te analyseren.",
  track_ride_title: 'We helpen u uw rit te volgen:',
  track_ride_paragraph:
    'Wij helpen chauffeurs op specifieke locaties samen te komen en tonen hen waar de passagiers die ze ophalen of afzetten zich bevinden. Chauffeurs kunnen ook de route op hun scherm volgen om tijd en moeite te besparen, en ervoor zorgen dat ze zowel hun telefoonnummer als geolocatie dichtbij hebben, zodat ze nooit een oproep of bericht van passagiers missen. Deze gegevens worden alleen verzameld wanneer de app geactiveerd is (in gebruik). Chauffeurs in sommige landen kunnen het telefoonnummer van de passagier niet meer zien in de app nadat de app is gesloten. Dit wordt gedaan om te voorkomen dat persoonlijke informatie toegankelijk is voor chauffeurs.',
  smooth_journey_title: 'Om uw reis soepel te laten verlopen:',
  smooth_journey_paragraph:
    'Geolocatiegegevens worden gebruikt om werknemers automatisch naar hun bestemming te krijgen en de tijd die verloren gaat door een verkeerde locatie te verminderen. Het helpt ook om ervoor te zorgen dat de facturen correct zijn.',
  app_performance_title: 'We zorgen voor de optimale prestaties van de app:',
  app_performance_paragraph:
    'We gebruiken uw contactgegevens om u te informeren over wijzigingen in onze app. We waarderen het dat u onze service blijft gebruiken, en deze updates helpen u ervoor te zorgen dat u de laatste versie van onze service gebruikt. We verzamelen beperkte gegevens van uw apparaat om onze service te verbeteren (IP-adres en gegevens die u helpen verbinding te maken met internet). Deze controles helpen uw account veilig te houden en uw authenticatie te verifiëren.',
  quick_ride_title:
    'Om u een snelle, goedkope en meest handige rit aan te bieden:',
  quick_ride_paragraph:
    'We verzamelen gegevens over de routes die onze passagiers en chauffeurs nemen om de geografische dekking te analyseren. Deze functie stelt ons in staat om de meest efficiënte routes voor chauffeurs en onze scooters te vinden. Het helpt ook om ervoor te zorgen dat onze medewerkers dicht bij klanten zijn.',
  collect_payment_title: 'We verzamelen uw betaling:',
  collect_payment_paragraph:
    "We verkrijgen betalingsgegevens om betalingen van passagiers te verwerken voor chauffeurs die onze rit-halen app gebruiken. Deze worden meestal gebruikt voor transacties zoals carpoolen en taxi's.",
  maintain_standards_title: 'We handhaven en bevorderen normen:',
  maintain_standards_paragraph:
    'We verzamelen gegevens over ritten, zoals of een rit is beëindigd of wanneer deze heeft plaatsgevonden. Hiermee moedigen we klantveiligheid aan en zorgen we voor naleving van onze voorwaarden. We willen er ook voor zorgen dat iedereen tevreden is met hun ervaring bij ons. Klantenservice is een belangrijk aspect van elk bedrijf, en feedback over de kwaliteit van uw klantenservice kan nuttig zijn. Het helpt bij het oplossen van geschillen en geeft het gevoel dat uw bedrijf om de klantbeleving geeft.',
  keep_informed_title: 'We houden u op de hoogte:',
  keep_informed_paragraph:
    'We gebruiken uw naam, telefoonnummer en e-mailadres om u te laten weten of uw rit is voltooid of om u andere reisgerelateerde informatie te sturen.',
  legal_basis_title: '3. Juridische basis',
  legal_basis_paragraph_1:
    'Wij mogen uw gegevens gebruiken zoals hierboven beschreven als u een geldige reden heeft om dit te doen. Uw informatie is altijd gekoppeld aan een expliciete behoefte van uw kant, en wij zorgen ervoor dat elk gebruik gerechtvaardigd is.',
  legal_basis_paragraph_2:
    'Wij verwerken uw persoonlijke gegevens om de gepersonaliseerde service te bieden die u wenst. Persoonlijke gegevens kunnen worden verwerkt om te voldoen aan onze algemene voorwaarden, zodat we u een ongeëvenaarde service kunnen bieden.',
  legal_basis_paragraph_3:
    'We bevestigen met u of we uw persoonlijke gegevens nodig hebben om uw verzoek te verwerken of of het onder legitiem belang valt. Onze legitieme belangen omvatten het bieden van een innovatieve, gepersonaliseerde en veilige service aan onze passagiers en partners. Dit gebeurt ten koste van andere belangen, inclusief winstgevendheid. Onze legitieme belangen omvatten activiteiten zoals het onderzoeken van fraude en andere kwaadwillige activiteiten, het handhaven van de veiligheid van onze systemen en het reageren op mogelijke criminele activiteiten.',
  legal_basis_paragraph_4:
    'Soms vertrouwen we op andere juridische gronden wanneer:',
  legal_basis_paragraph_5:
    'Voldoen aan een wettelijke verplichting, zoals het verwerken van gegevens wanneer dat vereist is, kan voordelig zijn. Dit gebeurt bijvoorbeeld wanneer er een geldige wettelijke aanvraag is.',
  legal_basis_paragraph_6:
    'In geval van nood of wanneer er een bedreiging voor het leven is.',
  legal_basis_paragraph_7:
    'We streven er altijd naar om transparant te zijn in al onze communicatie met u. Dit omvat de vereisten voor toestemming voor specifieke doeleinden, evenals informatie over hoe we uw metadata beoordelen, gebruiken en bewaren.',
  legal_basis_paragraph_8:
    'Het verkrijgen van persoonlijke informatie om een contract af te ronden is belangrijk en kan het bedrijf in staat stellen bepaalde juridische gevolgen te vermijden. Dit kan ook betekenen dat ze u geen diensten kunnen leveren. Wanneer u onze app downloadt, verzamelen en verwerken wij uw persoonlijke gegevens, zoals locatie-informatie, zodat chauffeurs u snel kunnen vinden. Het weigeren om uw locatie te delen, maakt het onmogelijk voor chauffeurs om u te vinden of reserveringen te zoeken. Wij zullen u niet toestaan om u aan te melden of uw account te gebruiken als we redelijkerwijs vermoeden dat u probeert de verplichtingen te omzeilen.',

  recipients_title: '4. Ontvangers',
  recipients_paragraph_1:
    'We werken alleen samen met vertrouwde partners en autoriteiten. We delen altijd alleen wat noodzakelijk is en niets meer. We weten dat gegevens waardevol kunnen zijn, dus we verkopen uw persoonlijke informatie niet aan bedrijven die deze tegen u kunnen gebruiken.',
  recipients_paragraph_2:
    'Wanneer een rit wordt aangevraagd, deelt het bedrijf uw persoonlijke gegevens met de chauffeur. Dit omvat alle gegevens zoals naam, contactnummer en locatie, evenals andere demografische informatie. Nadat de transportdienst is voltooid, blijven uw gegevens 24 tot 48 uur zichtbaar voor de chauffeur. Dit is belangrijk omdat het supervisors in staat stelt om contact op te nemen met de chauffeur en het probleem op te lossen, bijvoorbeeld als er iets in de auto is achtergelaten. Passagiers geven up-to-date feedback over hun ritten via onze app. De gegevens zijn anoniem en blijven privé tussen u en het bedrijf. Zelfs als iemand u een slechte beoordeling geeft, kunnen ze uw feedback niet tegen u gebruiken, of het zal niet meer nauwkeurig zijn. In sommige gevallen zijn we wettelijk verplicht om informatie te delen met externe ontvangers, zoals wanneer een rechtbank ons dit beveelt of wanneer we samenwerken met een toezichthoudende autoriteit voor gegevensbescherming. We voeren vaak deze reacties uit wanneer we te goeder trouw geloven dat de reactie wettelijk vereist is in die jurisdictie, wanneer het een taak van algemeen belang bevordert, gebruikers in die jurisdictie beïnvloedt en in overeenstemming is met onze gebruiksvoorwaarden. We hebben een sterke juridische basis om de informatie te delen en zullen onze beslissing documenteren door een rechtvaardiging te verstrekken.',

  security_title: '5. Beveiliging van uw persoonlijke gegevens',
  security_paragraph_1:
    'Gegevensbeveiliging is een van onze hoogste prioriteiten, maar uw gegevens zijn mogelijk niet volledig beveiligd. Terwijl wij streven naar het gebruik van door de industrie geaccepteerde methoden voor gegevensbeveiliging, moet u er rekening mee houden dat geen enkele methode van transmissie via internet of elektronische opslag 100% veilig is.',

  children_privacy_title: '6. Privacy van kinderen',
  children_privacy_paragraph_1:
    'We richten ons niet tot personen onder de 13 jaar. We verzamelen niet opzettelijk persoonlijke informatie van personen onder de 13 jaar. Als u een ouder of voogd bent en u merkt dat uw kind ons persoonlijke gegevens heeft verstrekt, neem dan contact met ons op. We zijn ons ervan bewust dat we persoonlijke gegevens van personen onder de 13 jaar hebben verzameld zonder ouderlijke toestemming op onze servers te verifiëren. Als dit gebeurt, verwijderen we de informatie van onze servers.',
  children_privacy_paragraph_2:
    'Sommige van onze diensten zijn alleen beschikbaar voor gebruikers ouder dan 13 jaar. In bepaalde gevallen betekent dit dat we bepaalde functies of functionaliteit van de dienst niet aan deze jongere gebruikers kunnen bieden.',
  children_privacy_paragraph_3:
    'Als de wet ons verplicht om de toestemming van uw ouders in te winnen om persoonlijke gegevens te verzamelen en te verwerken, kunnen we dit niet doen tenzij u ons hun toestemming geeft.',

  links_title: '7. Links naar andere websites',
  links_paragraph_1:
    'We kunnen links naar andere websites opnemen die niet door ons worden beheerd. Als u op een externe link klikt, wordt u naar die website geleid. Het is belangrijk dat u het privacybeleid van elke site die u bezoekt leest.',
  links_paragraph_2:
    'We censureren geen externe sites of de inhoud op die sites. We hebben geen controle over en nemen geen verantwoordelijkheid voor de inhoud, beveiliging, privacybeleid of praktijken van externe sites waarmee we zijn gekoppeld.',

  changes_title: '8. Wijzigingen in dit privacybeleid',
  changes_paragraph_1:
    'We zullen ons privacybeleid van tijd tot tijd bijwerken. Als er een wijziging wordt aangebracht, zullen we u hiervan op de hoogte stellen via het forum of via andere middelen.',
  changes_paragraph_2:
    "Een e-mail of een opvallende melding wordt verzonden voordat de wijziging van kracht wordt, om de aanstaande wijzigingen te melden en een update te geven met de datum 'Laatst bijgewerkt' bovenaan dit privacybeleid.",
  changes_paragraph_3:
    'Bezoekers dienen periodiek de privacyverklaring te controleren op eventuele wijzigingen die op deze site zijn geplaatst. Wijzigingen in het privacybeleid blijven van kracht totdat een nieuwe versie op deze pagina wordt gepost.',

  rights_title: '9. Uw rechten en controle',
  rights_paragraph_1:
    'We willen dat u de controle over uw persoonlijke gegevens behoudt. We bieden u de nodige controle in de app om elke bit informatie te bekijken die we over onze gebruikers verzamelen, inclusief hun profielgegevens en reisgeschiedenis. We hebben ook instellingen in de app, zoals marketingopt-ins en duidelijke cookie-toestemmingsinstellingen.',
  rights_paragraph_2: 'Uw recht op toegang',
  rights_paragraph_3:
    'U heeft het recht om een kopie te vragen van alle persoonlijke informatie die we over u hebben verzameld. We kunnen mogelijk niet altijd alle informatie verstrekken die u van ons vraagt, omdat we onze rechten moeten afwegen tegen die van anderen.',
  rights_paragraph_4: 'Uw recht op rectificatie',
  rights_paragraph_5:
    'U kunt betere ondersteuning krijgen voor al uw persoonlijke gegevens in de app. U heeft ook het recht om ons te vragen om records bij te werken of te voltooien die u onvolledig acht. Op deze manier heeft u het gemakkelijker om alles goed in te stellen en soepel te laten draaien.',
  rights_paragraph_6: 'Uw recht op wissen',
  rights_paragraph_7:
    'U kunt verzoeken dat uw persoonlijke gegevens die op onze servers zijn opgeslagen, onder bepaalde omstandigheden worden verwijderd.',
  rights_paragraph_8: 'Uw recht op beperking van verwerking',
  rights_paragraph_9:
    'U heeft het recht om ons te vragen de verwerking van uw gegevens in bepaalde gevallen te beperken. Bijvoorbeeld als u een klacht indient bij het bedrijf of als u juridische rechten wilt uitoefenen (zoals het claimen van schadevergoeding voor schade of als uw gegevens zijn gehackt).',
  rights_paragraph_10: 'Uw recht om bezwaar te maken tegen verwerking',
  rights_paragraph_11:
    'We verwerken uw gegevens op basis van legitieme belangen. Als u bezwaar wilt maken, kunt u ons dat laten weten en vragen om een persoon het te laten herzien.',

  retention_title: '10. Bewaring van gegevens',
  retention_paragraph_1:
    'Onze app bewaart de gegevens van gebruikers alleen zolang het nodig is om aan hun beleidsregels te voldoen. Alle categorieën gegevens (bijv. facturering, locatie) worden gedurende verschillende periodes opgeslagen, afhankelijk van het type (bijv. 6 weken voor factureringsgegevens, 12 maanden voor locatiegegevens).',
  retention_paragraph_2:
    "Na het hebben van een actief account met onze service, worden je persoonlijke gegevens bij ons bewaard zolang je gebruik maakt van onze diensten. Je kunt je account permanent deactiveren of je persoonlijke gegevens via de app verwijderen indien nodig. Als je account wordt gesloten, worden persoonlijke gegevens verwijderd volgens onze bewaarschema's en regels. Gegevens over vervoersdiensten die aan passagiers zijn geleverd, worden drie jaar na de laatste rit bewaard; gegevens voor andere boekhoudkundige doeleinden worden zeven jaar na de laatste rit bewaard.",
  retention_paragraph_3:
    'We bewaren alle benodigde gegevens voor interne, juridische en regelgevende vereisten om ervoor te zorgen dat we een compliant bedrijf zijn. In het geval van betalingsclaims worden je persoonlijke gegevens bewaard, tenzij de claim is opgelost of is verlopen. De persoonlijke ritgeschiedenis en gebruiksgegevens van een individu worden 3 jaar bewaard, waarna deze privé worden gemaakt door de gegevens te anonimiseren. Informatie over jou wordt veilig opgeslagen en alleen gebruikt wanneer dat nodig is voor deze doeleinden. We bewaren de gegevens die nodig zijn voor ons bedrijf, specifiek voor de doeleinden van het bedrijf, die in de loop van de tijd kunnen veranderen. De informatie wordt niet verzameld of gedeeld met een andere partij. Soms moeten we je gegevens bewaren om te voldoen aan onze wettelijke verplichtingen en onze overeenkomsten en beleid af te dwingen.',
  retention_paragraph_4:
    'Het bedrijf zal gebruikersgegevens ook voor interne analyse doeleinden bewaren. Gebruikersgegevens worden voor een kortere periode bewaard, tenzij ze worden gebruikt om de beveiliging te versterken of de functionaliteit van onze service te verbeteren, of we zijn wettelijk verplicht deze gegevens langer te bewaren.',

  contact_title: 'Neem contact met ons op',
  contact_paragraph_1:
    'Als u vragen heeft over dit privacybeleid, kunt u contact met ons opnemen: ',
  contact_paragraph_2: 'Per e-mail: manuelnobelapp@gmail.com',

  termsAndConditions_title: 'Algemene Voorwaarden',
  termsAndConditions_intro_title: 'Welkom bij de NOBEL-app!',
  termsAndConditions_intro_paragraph:
    'NOBEL presenteert u deze Algemene Voorwaarden met betrekking tot de levering van diensten, evenals de informatie, elementen, gegevens en vereisten die daarin zijn opgenomen en die eigendom zijn van Nobel-app, gevestigd aan Petrus Huysegomsstraat 5, Sint-Pieters-Leeuw, met bedrijfsnummer: 0744.455.5, hierna kort "NOBEL" genoemd.',
  aboutTheAppTitle: 'Over de NOBEL-app',
  aboutTheAppIntro:
    'Om deze Algemene Voorwaarden te begrijpen, is het noodzakelijk om te begrijpen:',
  appDefinition: {
    title: '1.1 "NOBEL-app (hierna de App)"',
    description:
      'De software die een reeks diensten aanbiedt en hun contract elektronisch en op afstand mogelijk maakt;',
  },
  termsAndConditionsDefinition: {
    title: '1.2 "Algemene Voorwaarden"',
    description:
      'De algemene voorwaarden die de toegang en het gebruik van de NOBEL-app door de gebruikers bepalen;',
  },
  personalDataDefinition: {
    title: '1.3 "Persoonlijke Gegevens"',
    description:
      'Betekent informatie met betrekking tot een geïdentificeerde of identificeerbare natuurlijke persoon ("Betrokkene"); een natuurlijke persoon wordt als identificeerbaar beschouwd als hij of zij direct of indirect kan worden geïdentificeerd, met name door te verwijzen naar een identificator, zoals een naam, een identificatienummer, locatiegegevens (zie Privacybeleid);',
  },
  serviceProviderDefinition: {
    title: '1.4 "Dienstverlener"',
    description:
      'Een natuurlijke of rechtspersoon met wie NOBEL een commerciële overeenkomst heeft op basis waarvan deze zijn diensten op de Applicatie aanbiedt en die diensten direct aan de Gebruiker zal leveren;',
  },
  provisionOfServicesDefinition: {
    title: '1.5 "Dienstverlening"',
    description:
      'De diensten die beschikbaar zijn op de NOBEL-app en het contract tussen de Dienstverleners en de Gebruikers;',
  },
  userDefinition: {
    title: '1.6 "Gebruiker"',
    description:
      'Een natuurlijke persoon, ouder dan 18 jaar, die toegang heeft tot en de Applicatie gebruikt in overeenstemming met deze Algemene Voorwaarden;',
  },
  contractDefinition: {
    title: '1.7 "Contract"',
    description:
      'Betekent een commerciële overeenkomst tussen de Dienstverlener en NOBEL, die het volgende omvat:',
  },
  contractDetails: {
    termsAndConditions: '1.7.1 Deze Algemene Voorwaarden;',
    specialTerms:
      '1.7.2 Speciale voorwaarden die in de NOBEL-app worden bekendgemaakt, bijvoorbeeld met betrekking tot prijzen of beschrijvingen van diensten;',
    additionalTerms:
      '1.7.3 Aanvullende Algemene Voorwaarden of documenten die in de toekomst tussen de Dienstverlener en NOBEL moeten worden ondertekend.',
  },
  priceDefinition: {
    title: '1.8 "Prijs"',
    description:
      'Het bedrag dat de Gebruiker moet betalen aan de Dienstverlener voor de geleverde diensten, evenals het bedrag dat moet worden ingehouden voor de betaling van de bemiddeling door NOBEL.',
  },
  intermediationFeesDefinition: {
    title: '1.9 "Bemiddelingskosten"',
    description:
      'Betekent de kosten die de Dienstverlener aan NOBEL moet betalen voor het gebruik van het Platform.',
  },
  paymentsDefinition: {
    title: '1.10 "Betalingen"',
    description:
      'Kaart, betalingssysteem en andere betaalmethoden die door gebruikers via NOBEL worden gekozen om te betalen voor de levering van diensten.',
  },

  acceptanceAndConclusionTitle:
    'Aanvaarding en afsluiting van het contract met NOBEL',
  acceptanceAndConclusion: {
    item1:
      '2.1 Om toegang te krijgen tot de NOBEL-app, moet je de app installeren op je mobiele apparaat (of het nu een smartphone of tablet is, draaiend op iOS of Android).',
    item2:
      '2.2 Het downloaden en installeren van de NOBEL-app op je mobiele apparaat is gratis, hoewel er kosten verbonden kunnen zijn aan het gebruik van het telecommunicatienetwerk en mobiele data, die volledig en uitsluitend door de dienstverlener worden gedragen en betaald moeten worden door de dienstverlener volgens de voorwaarden van het contract met de relevante telecommunicatieoperator.',
    item3:
      '2.3 Na de aanmaak van het account wordt de authenticatie uitgevoerd, wat inhoudt dat de gebruiker, via SMS of e-mail, een beveiligingscode ontvangt, persoonlijk, vertrouwelijk en niet-overdraagbaar. De dienstverlener is verantwoordelijk voor het bewaren, de vertrouwelijkheid en de veiligheid hiervan.',
    item4:
      '2.4 De dienstverlener moet zijn inloggegevens vertrouwelijk houden en de toegang tot zijn account beperken, inclusief door zijn inloggegevens te beschermen tegen verlies, diefstal of misbruik. Elk verlies van inloggegevens moet aan NOBEL worden gemeld.',
    item5:
      '2.5 Schade die voortvloeit uit ongeautoriseerd gebruik van de identificatoren is de enige verantwoordelijkheid van de dienstverlener.',
    item6: '2.6 De dienstverlener verklaart en garandeert dat hij:',
    item6_1:
      '2.6.1 Het contract zorgvuldig heeft bekeken, begrepen en ermee akkoord gaat om gebonden te zijn aan dit contract, inclusief alle verplichtingen die hieruit voortvloeien voor de dienstverlener zoals hier beschreven;',
    item6_2:
      '2.6.2 Het anderen niet toestaat het account van de dienstverlener te gebruiken, of het over te dragen of toe te wijzen aan andere personen zonder de uitdrukkelijke schriftelijke toestemming van NOBEL;',
    item6_3:
      '2.6.3 Het de app-software of andere NOBEL-inhoud niet zal kopiëren of distribueren zonder de voorafgaande schriftelijke toestemming van NOBEL.',
    item7:
      '2.7 In het geval van een schending van een toepasselijke wettelijke bepaling, deze Algemene voorwaarden of andere toepasselijke contractuele bepalingen, behoudt NOBEL zich het recht voor om het account van de dienstverlener op te schorten of te beëindigen of andere maatregelen te nemen die zij naar eigen goeddunken passend acht.',
  },
  contractualRelationshipTitle:
    'Contractuele relatie tussen de dienstverlener en de gebruiker',
  contractualRelationship: {
    item1:
      '3.1 De dienstverlener stemt ermee in dat hij een dienstverleningscontract met de gebruiker kan aangaan.',
    item2:
      '3.2 De diensten worden door de dienstverlener geleverd als een onafhankelijk bedrijf en de dienstverlener wordt daarom niet beschouwd als een werknemer of arbeider of equivalent ten opzichte van NOBEL, met betrekking tot de geleverde diensten.',
    item3:
      '3.3 Niettegenstaande het feit dat NOBEL geen partij is in de contractuele relatie tussen de dienstverlener en de gebruiker, verbindt de dienstverlener zich ertoe:',
    item3_1:
      '3.3.1 Een verzekering voor arbeidsongevallen af te sluiten (conform Wet nr. ______ ;',
    item3_2:
      '3.3.2 Zorgen voor veiligheid en gezondheid op het werk (conform de algemene bepalingen van Wet nr. ______);',
    item3_3:
      '3.3.3 Ervoor zorgen dat al zijn medewerkers en/of dienstverleners in staat zijn om te werken (conform het Reglement _____________);',
    item3_4:
      '3.3.4 Geen diensten te verlenen onder invloed van alcohol of drugs en geen maatregelen te nemen die schadelijk zijn of de veiligheid van gebruikers of derden kunnen schaden, wat het imago en de geloofwaardigheid van NOBEL zou kunnen beïnvloeden;',
    item3_5: '3.3.5 Zich zorgvuldig gedragen, risicovol gedrag vermijden;',
    item3_6:
      '3.3.6 Aansprakelijkheidsverzekering en andere vereiste verzekeringen af te sluiten die in de toepasselijke jurisdictie nodig zijn voor de levering van thuishulpdiensten;',
    item3_7:
      '3.3.7 Alle benodigde apparatuur, materialen en middelen voor de levering van de diensten te hebben, waarvan de kosten door hem/haar zelf worden gedragen, inclusief brandstof voor reizen.',
  },
  priceTitle: 'Prijs',
  price: {
    item1:
      '4.1 De prijs van de service is vastgesteld in de NOBEL-app, evenals de toepasselijke wettelijke belastingen. Evenzo kan de serviceprovider het bedrag zien dat verband houdt met het intermediatietarief van 30% dat aan NOBEL wordt betaald en dat automatisch wordt ingehouden.',
    item2:
      '4.2 Aan de andere kant biedt de NOBEL-app ook een prijs voor elk extra uur van de service, die door de serviceprovider moet worden geactiveerd in gevallen waarin, door een onjuiste, onnauwkeurige of onvoldoende beschrijving van de gebruiker, het werk complexer blijkt te zijn dan gevraagd. De gebruiker heeft de optie om te kiezen of hij door wil gaan met het verlenen van de service of deze wil weigeren.',
    item3:
      '4.3 Als de gebruiker de nieuwe prijs niet accepteert, wordt de service geannuleerd, wat leidt tot een betaling van 30 €.',
  },
  meansOfPaymentTitle: 'Betalingsmethoden',
  meansOfPayment: {
    item1:
      '5.1 De Serviceprovider verplicht zich om geldige, actuele en volledige creditcard- of debetkaartgegevens te verstrekken bij het registreren voor de NOBEL-app.',
    item2:
      '5.2 Betalingen worden elke 15 dagen gedaan, zodat NOBEL de effectiviteit en het succes van de geleverde diensten kan garanderen.',
    item3:
      '5.3 Als NOBEL niet in staat is om een verschuldigd bedrag voor een dienst of een ander bedrag van de creditcard of debetkaart van een gebruiker te incasseren, behouden we ons het recht voor om tijdelijk al hun toegang tot de applicatie te onderbreken of uit te schakelen. Dit doet geen afbreuk aan andere rechten of rechtsmiddelen die beschikbaar zijn voor ons (als incassant namens de Serviceprovider), en voor de Serviceprovider.',
    item4:
      '5.4 Betalingen worden verricht door een onafhankelijke derde partij die het bedrag van de service behoudt voordat deze wordt uitgevoerd, dit bedrag wordt van de creditcard van de gebruiker afgeschreven.',
    item5:
      '5.5 De factuur wordt door NOBEL per digitale vorm verzonden naar het e-mailadres dat door de Serviceprovider is opgegeven, nadat is bevestigd dat de serviceverlening succesvol is afgerond.',
  },
  userIdentificationTitle: 'Gebruikersidentificatie',
  userIdentification: {
    item1:
      '6.1 Voordat de dienstverlening wordt gestart, verplicht de dienstverlener zich om naar het opgegeven adres te gaan en de gebruiker te identificeren.',
    item2:
      '6.2 Als de dienstverlener een fout maakt bij het identificeren van de gebruiker en de betaling wordt gedaan door iemand die de service niet heeft ontvangen, zal NOBEL het bedrag terugbetalen aan de gebruiker. In dit geval heeft de dienstverlener geen recht op het tarief dat overeenkomt met de geleverde diensten en zal hij de kosten voor de terugbetaling aan NOBEL dragen.',
  },
  Responsibilitytitle: 'Verantwoordelijkheid',
  Responsibility: {
    item1:
      '7.1 NOBEL is op geen enkele wijze partij bij de contractueel vastgestelde relatie tussen de Gebruiker en de Dienstverlener. Dienovereenkomstig erkennen zij dat er geen aansprakelijkheid aan NOBEL kan worden toegerekend, in het bijzonder met betrekking tot de uitvoering van het contract en de naleving van de contractuele verplichtingen van de partijen.',
    item2:
      '7.2 Evenzo kan NOBEL niet aansprakelijk worden gesteld voor het niet-nakomen van een contract door een van de partijen of voor extra-contractuele aansprakelijkheid, evenals voor enig verlies of schade die daaruit kan voortvloeien voor een van de partijen.',
    item3:
      '7.3 NOBEL garandeert niet de permanente of ononderbroken werking van de NOBEL App. Daarom kan NOBEL niet aansprakelijk worden gesteld voor de onmogelijkheid om deze te gebruiken of voor enige schade of nadelen die daaruit voortvloeien:',
    item3_1:
      '7.3.1 Moeilijkheden bij het gebruik van de App veroorzaakt door vertragingen, onderbrekingen, fouten, interferentie of opschorting van communicatie, virussen, bugs of storingen;',
    item3_2:
      '7.3.2 Vertragingen veroorzaakt door gebreken of overbelasting van internetverkeer of andere elektronische systemen;',
    item3_3:
      '7.3.3 Onrechtmatige handelingen van derden, fouten of beveiligingsgebreken als gevolg van het gebruik van verouderde of onveilige apparatuur of browsers, storingen van de elektronische communicatiediensten die door de Dienstverlener worden gebruikt, evenals schade, fouten en onnauwkeurigheden die kunnen voortvloeien uit hun storing.',
    item4:
      '7.4 De Dienstverlener neemt de volledige verantwoordelijkheid voor zijn handelingen of omissies en de gevolgen daarvan, en vrijwaart NOBEL van enige aansprakelijkheid voor directe of indirecte handelingen, of het nu gaat om incidentele of criminele handelingen, in verband met misbruik of illegaal gebruik van de NOBEL App.',
    item5:
      '7.5 De Dienstverlener erkent en stemt ermee in dat er geen aansprakelijkheid, direct of indirect, kan worden toegerekend aan NOBEL als gevolg van het gebruik van de NOBEL App.',
    item6:
      '7.6 De Dienstverlener is verantwoordelijk voor het gebruik van de NOBEL App, zelfs als deze door derden wordt gemaakt, met of zonder zijn toestemming. Als echter wordt aangetoond dat een transactie door een derde partij is uitgevoerd, wordt aangenomen dat deze door de Dienstverlener is goedgekeurd of nalatig mogelijk gemaakt.',
    item7:
      '7.7 De Dienstverlener en NOBEL komen overeen dat de computerregistratie of reproductie op elk medium, inclusief papier, als bewijs wordt beschouwd van de verrichte handelingen in overeenstemming met deze Algemene Voorwaarden.',
    item8:
      '7.8 NOBEL neemt geen aansprakelijkheid voor enig verlies of schade die de Dienstverlener zou kunnen lijden in verband met het contract dat met de Gebruiker is gesloten of voortvloeiend uit het gebruik van de NOBEL App, inclusief, maar niet beperkt tot:',
    item8_1:
      '7.8.1 Elk ongeval dat zich voordoet bij de levering van diensten;',
    item8_2:
      '7.8.2 Elke directe of indirecte materiële schade of financieel verlies;',
    item8_3: '7.8.3 Verlies van winst of verwachte winst;',
    item8_4:
      '7.8.4 Verlies van bedrijf, contracten, contacten, prestige, reputatie en elk verlies dat kan voortvloeien uit bedrijfs onderbreking;',
    item8_5: '7.8.5 Verlies of onnauwkeurigheid van gegevens;',
    item8_6: '7.8.6 Elke andere indirecte of gevolgschade.',
  },
  Sanctions: {
    title: 'Sancties',
    description:
      'NOBEL behoudt zich het recht voor om elke Dienstverlener die gebruik maakt van de NOBEL-app, onmiddellijk en zonder voorafgaande kennisgeving, uit te sluiten, die:',
    item1:
      '8.1 Overtreedt of vermoed wordt te hebben overtreden van een van de bepalingen van deze Algemene Voorwaarden en het bijbehorende Privacybeleid;',
    item2:
      '8.2 De NOBEL-app gebruikt met valse, onjuiste of onvolledige registratiegegevens;',
    item3: '8.3 De NOBEL-app frauduleus gebruikt;',
    item4:
      "8.4 Manipuleert, wijzigt, verwijdert of wist gegevens, programma's of computersystemen die gekoppeld zijn aan de NOBEL-app;",
    item5:
      '8.5 Direct contact opneemt met gebruikers van de NOBEL-app, op welke manier dan ook, om samenwerkingsverbanden of zakelijke relaties aan te gaan;',
    item6:
      '8.6 Is gemeld voor frauduleus of schadelijk gedrag dat de reputatie en geloofwaardigheid van NOBEL kan schaden.',
  },
  IntellectualPropertyRightsTitle: 'Intellectuele eigendomsrechten',
  IntellectualPropertyRights: {
    item1:
      '9.1 Door de NOBEL-app te installeren en te gebruiken, erkent en stemt de dienstverlener ermee in dat de intellectuele eigendomsrechten op alle inhoud van de NOBEL-app toebehoren aan NOBEL, inclusief de informatie, tools, grafische ontwerpen, alle mediacomponenten, het logo en alle cijfers of teksten.',
    item2:
      '9.2 Het volledig of gedeeltelijk reproduceren van informatie of inhoud van de NOBEL-app, de verhuur of verkoop ervan, zonder voorafgaande toestemming van NOBEL, is verboden.',
    item3:
      '9.3 De onderscheidende tekens van de NOBEL-app zijn beschermd en mogen niet door derden worden gebruikt zonder voorafgaande en uitdrukkelijke toestemming van NOBEL.',
    item4:
      '9.4 Het is de dienstverlener strikt verboden om te proberen toegang te krijgen tot, te wijzigen, te reproduceren, te verspreiden, te verkopen, te licentiëren of de inhoud van NOBEL en de intellectuele eigendomsrechten daarvan geheel of gedeeltelijk te kopiëren.',
    item5:
      '9.5 Alle intellectuele eigendomsrechten op de software, de inhoud ervan en enige bijbehorende documentatie, in welk land dan ook, behoren toe aan NOBEL of haar licentiegevers en mogen niet worden gekopieerd, gedistribueerd, gedownload, herpubliceerd, gedecompileerd, gedeassembleerd of op enige andere manier worden verzonden zonder de voorafgaande schriftelijke toestemming van NOBEL.',
  },
  UserRatingsTitle: 'Gebruikersbeoordelingen',
  UserRatings: {
    item1:
      '10.1 NOBEL streeft ernaar de kwaliteit, efficiëntie en het succes van de diensten die het aanbiedt op zijn platform aan gebruikers te waarborgen. In dit verband is de evaluatie van de gebruiker een beslissend element voor het voortzetten van de contractuele relatie tussen NOBEL en de Serviceprovider.',
    item2:
      '10.2 De gebruiker kan opmerkingen achterlaten en de kwaliteit van de verwelkoming en de geleverde service beoordelen van 1 tot 5.',
    item3:
      '10.3 In het geval dat de Serviceprovider drie keer wordt beoordeeld met scores onder de 3 op een schaal van 1 tot 5, kan NOBEL contact opnemen om opheldering te geven. Onverminderd het bovenstaande, behoudt NOBEL zich het recht voor om het contract tussen NOBEL en de Serviceprovider onmiddellijk en zonder kennisgeving te beëindigen.',
  },
  TermAndTerminationTitle: 'Duur en Beëindiging',
  TermAndTermination: {
    item1:
      '11.1 De Dienstverlener kan de Overeenkomst te allen tijde beëindigen door NOBEL ten minste 15 (vijftien) dagen van tevoren schriftelijk op de hoogte te stellen.',
    item2:
      '11.2 NOBEL kan de Overeenkomst te allen tijde en om welke reden dan ook beëindigen, naar eigen goeddunken, door de Dienstverlener ten minste 5 (vijf) dagen van tevoren te informeren.',
    item3:
      '11.3 NOBEL behoudt zich het recht voor om de Overeenkomst te beëindigen en de toegang van de Dienstverlener zonder voorafgaande kennisgeving te blokkeren in geval van een schending van de Overeenkomst en/of enige toepasselijke wet of regelgeving door de Dienstverlener.',
    item4:
      '11.4 Na beëindiging van deze Overeenkomst om welke reden dan ook, vervallen alle rechten die aan de Dienstverlener zijn verleend op grond van deze Overeenkomst onmiddellijk, en zal de Dienstverlener alle activiteiten die door deze Overeenkomst zijn toegestaan, stopzetten.',
  },
  DisputeResolutionTitle: 'Geschillenbeslechting',
  DisputeResolution: {
    item1:
      '12.1 In het geval van een geschil met betrekking tot de dienstverlening, neem dan eerst contact met ons op via het volgende e-mailadres: info@nobel-app.com.',
    item2:
      '12.2 In het onwaarschijnlijke geval dat een geschil niet op een vriendschappelijke manier kan worden opgelost, zullen we samen met de serviceprovider de meest effectieve manier bespreken om het geschil op te lossen.',
  },
  FinalTransitionalProvisionsTitle: 'Eind- en overgangsbepalingen',
  FinalTransitionalProvisions: {
    item1:
      '13.1 NOBEL behoudt zich het recht voor om de lay-out en configuratie van de NOBEL-app op elk moment en zonder voorafgaande kennisgeving eenzijdig te wijzigen.',
    item2:
      '13.2 NOBEL behoudt zich het recht voor om deze Algemene Voorwaarden van tijd tot tijd bij te werken.',
    item3:
      '13.3 Wijzigingen of updates kunnen gerechtvaardigd worden door de noodzaak om nieuwe functionaliteiten van de NOBEL-app te implementeren, evenals door wijzigingen in de toepasselijke wetgeving.',
    item4:
      '13.4 NOBEL zal zich inspannen om de Dienstverleners ten minste 14 (veertien) dagen van tevoren te informeren over wijzigingen of updates van deze Algemene Voorwaarden.',
    item5:
      '13.5 Indien een bepaling van deze Algemene Voorwaarden niet afdwingbaar of uitvoerbaar wordt geacht, heeft dit geen invloed op de afdwingbaarheid en geldigheid van de overige bepalingen.',
  },
  ApplicableLawAndJurisdictionTitle: 'Toepasselijk recht en jurisdictie',
  ApplicableLawAndJurisdiction: {
    item1:
      '14.1 De NOBEL-applicatie, evenals deze Algemene Voorwaarden, zijn onderworpen aan de wetgeving die van kracht is in het Belgische rechtsstelsel.',
    item2:
      '14.2 NOBEL en de gebruiker accepteren en stemmen ermee in dat elk geschil dat voortvloeit uit deze Algemene Voorwaarden, evenals het Privacybeleid dat ervan een integraal onderdeel uitmaakt, zal worden beslecht door de Rechtbank________________________________',
  },

  ItShouldBeAdded: 'Het moet worden toegevoegd:',
  ServiceProviderWorkNonCompliance:
    'In het geval dat de Serviceprovider het werk niet uitvoert volgens de vakregels en de kwaliteitsnormen die door NOBEL worden vereist, behouden wij ons uitdrukkelijk het recht voor om de betaling voor de betreffende dienst niet door te voeren.',
  QualifiedServiceProviderSubstitution:
    'NOBEL behoudt zich ook het recht voor om een andere gekwalificeerde serviceprovider in te schakelen om het oorspronkelijk gevraagde werk te corrigeren of aan te vullen.',
  QualityStandardsSatisfaction:
    'Deze maatregel is bedoeld om de tevredenheid van onze gebruikers te waarborgen en de hoge kwaliteitsnormen die NOBEL zich heeft gecommitteerd te handhaven.',
  AgreementAcknowledgment:
    'Door deze Algemene Voorwaarden te accepteren, erkent en accepteert de Serviceprovider deze bepaling, met het begrip dat het niet naleven van de kwaliteitsvereisten kan leiden tot het niet betalen voor zijn diensten en het nemen van corrigerende maatregelen door NOBEL.',
  about_title: 'Over',
  AboutDescription:
    'Welkom bij Nobel, waar gemak samenkomt met expertise! Bij Nobel begrijpen we de uitdagingen van het onderhouden van een huis of bedrijf, en we geloven dat iedereen toegang verdient tot betrouwbare en bekwame serviceprofessionals. Ons platform is ontstaan uit de visie om een naadloze verbinding te creëren tussen servicezoekers en -aanbieders, waardoor thuisdiensten toegankelijker, efficiënter en aangenamer worden.',
  MissionDescription:
    'Onze missie is om uw leven te vereenvoudigen door een alles-in-één oplossing te bieden voor al uw thuisservicebehoeften. Of het nu gaat om het repareren van een lekkende kraan, het opfrissen van uw woonruimte met een grondige schoonmaak of het oplossen van elektrische problemen, Nobel is hier om u in contact te brengen met gecertificeerde professionals die topservice leveren.',
  whyNobel: [
    {
      title: 'Kwaliteit waarop je kunt vertrouwen',
      description:
        'We stellen jouw tevredenheid en gemoedsrust centraal. Al onze dienstverleners ondergaan een rigoureus selectieproces om ervoor te zorgen dat ze voldoen aan de hoogste normen van professionaliteit en expertise.',
    },
    {
      title: 'Gemak binnen handbereik',
      description:
        'Met slechts een paar tikken op je smartphone kun je een verscheidenheid aan diensten boeken en vakbekwame professionals aan je deur krijgen. Zeg vaarwel tegen het gedoe van zoeken en plannen - Nobel regelt alles voor je.',
    },
    {
      title: 'Veiligheid eerst',
      description:
        'Jouw veiligheid is onze prioriteit. Ons platform zorgt ervoor dat alle transacties veilig zijn, en we bieden realtime tracking van dienstverleners, zodat je precies weet wanneer je ze kunt verwachten.',
    },
    {
      title: 'Diverse diensten',
      description:
        'Van loodgieterswerk en elektriciteit tot schoonmaken en tuinieren, we bieden een uitgebreid scala aan diensten om aan je unieke behoeften te voldoen. Wat de taak ook is, we hebben de juiste professional voor je.',
    },
    {
      title: 'Gebruiksvriendelijke ervaring',
      description:
        'Onze app is ontworpen om gebruiksvriendelijk te zijn, zodat je gemakkelijk kunt navigeren, diensten kunt boeken en communiceren met dienstverleners. We waarderen je tijd en ons platform is gebouwd om het hele proces naadloos te maken.',
    },
    {
      title: 'Betrouwbare Ondersteuning',
      description:
        'Wij zetten ons in voor uitstekende klantenservice. Ons toegewijde team staat altijd klaar om u te helpen met al uw vragen, zodat u een zorgeloze ervaring hebt.',
    },
  ],
  joinSection: {
    title: 'Word lid van de Nobel-gemeenschap',
    description:
      'Of je nu een servicezoeker bent die op zoek is naar betrouwbare professionals of een gekwalificeerde dienstverlener die zijn bedrijf wil laten groeien, Nobel verwelkomt je om deel uit te maken van onze gemeenschap. Samen herdefiniëren we de manier waarop thuisdiensten worden geleverd, waardoor het leven eenvoudiger en aangenamer wordt voor iedereen.',
  },
  sloganSection: {
    title: 'Ervaar het gemak, de betrouwbaarheid en de excellentie van Nobel.',
    subtitle:
      'Download de app vandaag nog en ontdek een nieuw tijdperk van thuisdiensten.',
  },
  product: 'Product',
  customer_app: 'Klantenapp',
  provider_app: 'Leverancier App',
  home_services: {
    line1: 'Thuisdiensten bij',
    line2: 'je deur.',
  },
  rights_reserved: 'Nobel. Alle rechten voorbehouden.',
  help: 'Hulp',
  delivery_message:
    'Snel, betrouwbaar en gegarandeerd om aan je verwachtingen te voldoen, rechtstreeks bij je thuis bezorgd.',
  home_services_title: 'Betrouwbare thuisdiensten',
  home_services_subtitle: 'Slechts een tik verwijderd!',
  services__top_title: 'Alle diensten',
  join_nobel_team:
    'Ben je een ervaren professional en wil je deel uitmaken van het Nobel-team van technici? Meld je nu aan!',
  work_with_us: 'Wil je met ons werken?',
  tell_us: 'Vertel ons waar je naar op zoek bent',
  your_name: 'Naam',
  your_email: 'E-mail',
  your_subject: 'Onderwerp',
  your_message: 'Bericht',
  submitting: 'Bezig met indienen...',
  success: 'Inzending geslaagd!',
  submit_request: 'Verzoek indienen',
  something_went_wrong: 'Er is iets mis gegaan, probeer het later opnieuw.',
  home_title: 'Startpagina',
  name_required: 'Naam is verplicht',
  email_required: 'Email is verplicht',
  invalid_email: 'Ongeldig emailformaat',
  message_required: 'Bericht is verplicht',
  captcha_required: 'Captcha vereist',
  subject_required: 'Onderwerp is verplicht',
  name_minlength: 'De naam moet minimaal 3 tekens bevatten.',
  name_maxlength: 'De naam mag niet langer zijn dan 50 tekens.',
  subject_minlength: 'Het onderwerp moet minimaal 3 tekens bevatten.',
  subject_maxlenght: 'Het onderwerp mag niet meer dan 30 tekens bevatten.',
  message_minlength: 'Het bericht moet minimaal 10 tekens bevatten.',
  message_maxlength: 'Het bericht mag niet meer dan 500 tekens bevatten.',
  regex_name: 'Controleer de naam',
  why_nobel: 'Waarom Nobel',
  what_makes_us: 'Wat maakt ons beter dan de rest.',

  faq: {
    general: {
      title: 'Algemeen',
      questions: [
        {
          question: 'Wat is Nobel?',
          answer:
            'Nobel is een handig platform dat je verbindt met vertrouwde en deskundige dienstverleners voor verschillende onderhouds- en reparatiewerkzaamheden in huis, zoals loodgieterswerk, elektriciteit, schoonmaak en meer.',
        },
        {
          question: 'Hoe werkt Nobel?',
          answer:
            'Download eenvoudig de app of bezoek onze website, selecteer de dienst die je nodig hebt, kies een dienstverlener en plan een afspraak op een moment dat jou uitkomt.',
        },
        {
          question: 'Is Nobel beschikbaar in mijn regio?',
          answer:
            'We breiden onze servicegebieden voortdurend uit. Voer je locatie in via de app of website om de beschikbaarheid te controleren.',
        },
      ],
    },
    booking: {
      title: 'Boekingen en diensten',
      questions: [
        {
          question: 'Hoe boek ik een dienst?',
          answer:
            'Je kunt een dienst boeken door de categorie te selecteren, een dienstverlener te kiezen en je afspraak te bevestigen. Betaling kan veilig via de app worden gedaan.',
        },
        {
          question: 'Kan ik een dienst van tevoren plannen?',
          answer:
            'Ja! Je kunt diensten boeken voor dezelfde dag of ze op een latere datum inplannen, afhankelijk van jouw beschikbaarheid.',
        },
        {
          question: 'Welke diensten bieden jullie aan?',
          answer:
            'Wij bieden verschillende diensten aan, waaronder: loodgieterswerk, elektriciteit, schoonmaak, tuinonderhoud, apparaatreparatie, schilderwerk, klusjes en meer.',
        },
      ],
    },
    pricing: {
      title: 'Prijzen en betalingen',
      questions: [
        {
          question: 'Hoe wordt de prijs bepaald?',
          answer:
            'De prijs is afhankelijk van het type dienst, de duur en de complexiteit. Je ziet een prijsindicatie voordat je je boeking bevestigt.',
        },
        {
          question: 'Welke betaalmethoden accepteren jullie?',
          answer:
            'Wij accepteren de meeste creditcards/debitcards, digitale portemonnees en andere veilige betaalmethoden die in jouw regio beschikbaar zijn.',
        },
        {
          question: 'Zijn er annuleringskosten?',
          answer:
            'Annuleringen binnen een bepaalde tijd zijn gratis. Last-minute annuleringen kunnen echter een kleine vergoeding met zich meebrengen. Bekijk ons annuleringsbeleid voor meer details.',
        },
      ],
    },
    support: {
      title: 'Ondersteuning en problemen',
      questions: [
        {
          question: 'Wat als ik niet tevreden ben met de dienst?',
          answer:
            'Jouw tevredenheid is onze prioriteit. Als je niet tevreden bent over een dienst, kun je contact opnemen met onze klantenservice om het probleem op te lossen.',
        },
        {
          question: 'Hoe neem ik contact op met de klantenservice?',
          answer:
            'Je kunt ons bereiken via de in-app chat, e-mail, telefoon of ons contactformulier.',
        },
        {
          question: 'Kan ik mijn boeking opnieuw plannen?',
          answer:
            'Ja, je kunt je afspraak wijzigen via de app, afhankelijk van de beschikbaarheid van de dienstverlener.',
        },
      ],
    },
  },
  servicestoptitle1: "Mannen's Salon",
  servicestoptitle2: 'Schoonheidssalon voor vrouwen',

  services_list1_top: {
    image01: [
      {
        largeDesc: 'Eenvoudige knipbeurt',
        smallDesc: "Mannen's salon",
      },
    ],
    image02: [
      {
        largeDesc: 'Baard trimmen',
        smallDesc: "Mannen's salon",
      },
    ],
    image03: [
      {
        largeDesc: 'Haarwas',
        smallDesc: "Mannen's salon",
      },
    ],
    image04: [
      {
        largeDesc: 'Gezichtsbehandeling',
        smallDesc: "Mannen's salon",
      },
    ],
    image05: [
      {
        largeDesc: 'Scherf',
        smallDesc: "Mannen's salon",
      },
    ],
  },
  services_list2_top: {
    image06: [
      {
        largeDesc: 'Pedicure',
        smallDesc: 'Schoonheidssalon voor vrouwen',
      },
    ],
    image07: [
      {
        largeDesc: 'Manicure',
        smallDesc: 'Schoonheidssalon voor vrouwen',
      },
    ],
    image08: [
      {
        largeDesc: 'Haarstyling',
        smallDesc: 'Schoonheidssalon voor vrouwen',
      },
    ],
    image09: [
      {
        largeDesc: 'Lichaamsmassage',
        smallDesc: 'Schoonheidssalon voor vrouwen',
      },
    ],
    image10: [
      {
        largeDesc: 'Gezichts Massage',
        smallDesc: 'Schoonheidssalon voor vrouwen',
      },
    ],
  },
  small_title_card1: 'Autowas',
  big_title_card1: "Krijg brandschone auto's",
  button_explore_card1: 'Ontdek nu',
  small_title_card2: 'Huishouden',
  big_title_card2: 'Maak je huis schoon zonder gedoe',
  button_explore_card2: 'Ontdek nu',
  services_bottom_title: 'Schoonmaak & Reparaties',

  services_list1_bottom: {
    image11: [
      {
        largeDesc: 'Eenvoudig kapsel',
        smallDesc: 'Herenkapper',
      },
    ],
    image12: [
      {
        largeDesc: 'Eenvoudig kapsel',
        smallDesc: 'Herenkapper',
      },
    ],
    image13: [
      {
        largeDesc: 'Eenvoudig kapsel',
        smallDesc: 'Herenkapper',
      },
    ],
  },
  "delete_account": "Account verwijderen",


  "delete_title": "Accountverwijdering aanvragen",
  "delete_description": "Voer hieronder uw telefoonnummer in om de verwijdering van uw account en alle bijbehorende gegevens aan te vragen.",
  "delete_phone_label": "Telefoonnummer (met landcode)",
  "delete_phone_placeholder": "Voer uw telefoonnummer in met landcode",
  "delete_button": "Verwijdering aanvragen",
  "delete_success": "Er is een bevestigingsmail voor verwijdering verzonden.",
  "delete_error": "Kan uw verzoek niet verwerken. Controleer uw telefoonnummer."

};
